var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"RequestButtonCreate"},[_c('v-tooltip',{staticClass:"tooltip",attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({staticClass:"icon",on:{"click":function($event){return _vm.$emit('click')}}},on),[_vm._v("mdi-plus-circle")])]}}])},[_vm._v("\n    Aanvraag aanmaken\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }